var _style, _defs, _path, _defs2, _path2, _defs3, _path3, _defs4, _polygon, _defs5, _path4, _defs6, _path5, _defs7, _path6, _defs8, _polygon2, _defs9, _path7, _defs0, _path8, _defs1, _polygon3, _defs10, _path9, _defs11, _path0, _defs12, _path1, _defs13, _path10, _defs14, _path11, _defs15, _path12, _defs16, _path13, _defs17, _path14, _defs18, _path15, _defs19, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMelb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 725.3 780.7",
    style: {
      enableBackground: "new 0 0 725.3 780.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:#CC2031;}\n\t.st1{clip-path:url(#SVGID_4_);fill:#0F1131;}\n\t.st2{clip-path:url(#SVGID_6_);fill:#CC2031;}\n\t.st3{clip-path:url(#SVGID_8_);fill:#CC2031;}\n\t.st4{clip-path:url(#SVGID_10_);fill:#CC2031;}\n\t.st5{clip-path:url(#SVGID_12_);fill:#CC2031;}\n\t.st6{clip-path:url(#SVGID_14_);fill:#CC2031;}\n\t.st7{clip-path:url(#SVGID_16_);fill:#CC2031;}\n\t.st8{clip-path:url(#SVGID_18_);fill:#CC2031;}\n\t.st9{clip-path:url(#SVGID_20_);fill:#CC2031;}\n\t.st10{clip-path:url(#SVGID_22_);fill:#CC2031;}\n\t.st11{clip-path:url(#SVGID_24_);fill:#CC2031;}\n\t.st12{clip-path:url(#SVGID_26_);fill:#CC2031;}\n\t.st13{clip-path:url(#SVGID_28_);fill:#CC2031;}\n\t.st14{clip-path:url(#SVGID_30_);fill:#CC2031;}\n\t.st15{clip-path:url(#SVGID_32_);fill:#CC2031;}\n\t.st16{clip-path:url(#SVGID_34_);fill:#CC2031;}\n\t.st17{clip-path:url(#SVGID_36_);fill:#CC2031;}\n\t.st18{clip-path:url(#SVGID_38_);fill:#CC2031;}\n\t.st19{clip-path:url(#SVGID_40_);fill:#CC2031;}\n\t.st20{clip-path:url(#SVGID_42_);fill:#CC2031;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 725.3,
    height: 780.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M361.1,780.4c-0.2,0-4.4-0.8-7.7-1.5c-25.5-5.9-90.9-34-155.8-98.2c-36.3-36-67-77.9-91.3-124.8 c-28.8-55.5-48.5-118-58.7-185.9L0,317.4V96.8l6-2.1c10.8-3.8,22-7.5,33.3-11V53.5l5.2-2.4C45.6,50.6,73,38,126.1,25.4 C174.8,13.8,255.3,0,362.7,0c59.3,0,148.4,4.4,236.6,25.4c53.1,12.6,80.5,25.2,81.6,25.7l5.2,2.4v30.2c11.3,3.5,22.5,7.2,33.3,11 l6,2.1v220.5l-47.9,54.5c-10.3,67.6-30.2,129.8-59,185c-24.3,46.6-54.9,88.4-91.2,124.2C462.6,745,397.4,773,372,778.9 c-3.3,0.8-7.5,1.5-7.7,1.6l-1.6,0.3L361.1,780.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    width: 725.3,
    height: 780.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M716.9,102.6c-13.1-4.6-26.2-8.8-39.3-12.9V58.7c0,0-108.3-50.2-314.4-50.2S48.8,58.7,48.8,58.7v31.1 c-13.1,4-26.2,8.3-39.3,12.9c0,70.3,0,140.5,0,210.8l47.1,52C99.7,659.9,308.1,758.6,356,769.6c3.1,0.7,7.2,1.5,7.2,1.5 s4.1-0.7,7.3-1.5c47.8-11,255.3-109.4,299-402.2l47.4-54C716.9,243.1,716.9,172.9,716.9,102.6"
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    width: 725.3,
    height: 780.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M640.6,296.2c-0.2,0-0.3-0.1-0.5-0.1c-11.8,323.2-224.6,427.7-270.5,438.6c-2.8,0.7-6.4,1.3-6.4,1.3 s-3.6-0.7-6.4-1.3C310.9,723.8,98,619.3,86.3,295.9c-0.2,0-0.3,0.1-0.5,0.1c4.1,337.9,224.2,446.1,271,457.2 c2.8,0.6,6.4,1.3,6.4,1.3s3.6-0.7,6.4-1.3C416.4,742.1,636.4,633.9,640.6,296.2"
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    width: 725.3,
    height: 780.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "297.3,413.6 345.7,551.6 345.8,482.4 316,394.9 316,394.9 301.3,351.7 301.3,351.7 297.3,339.8  262.1,339.8 273,355.3 273,612 262.7,627.3 307.5,627.3 297.3,612  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    width: 725.3,
    height: 780.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M254.8,532.9c-6-6.2-11.3-13.2-15.4-20.9c-4.2-7.9-7.2-16.6-8.3-25.5c-1.5-11.3-0.3-22.8,3.5-33.5 c2.8-8,6.9-15.5,12-22.2c5.4-7.2,11.8-13.6,18.8-19.2c0.8-0.6,1.6-1.3,2.4-1.9v-32.7c-0.3,0.2-0.7,0.3-1,0.5 c-2.8,1.7-5.7,3.2-8.5,4.9c-2.6,1.5-5,3.2-7.3,5c-4.4,3.4-8.6,7-12.6,10.8c-7.5,7.3-14,15.4-19.5,24.3c-5.2,8.5-9.6,17.6-13,26.9 c-1.7,4.8-3.3,9.6-4.9,14.4c-1.4,4-2.8,8.1-4.3,12.1c-0.1,0.3-0.3,0.7-0.3,0.9c0,0.3,0.3,0.8,0.4,1.1c0.5,1.4,1,2.9,1.6,4.3 c0.4,1.2,0.9,2.5,1.3,3.8c1.9,5.6,3.8,11.2,5.8,16.7c2.6,7.6,5.9,15,9.8,22.1c4.9,9,10.9,17.5,17.9,25.2c3.6,4,7.5,7.7,11.6,11.2 c4.4,3.8,8.9,7.4,13.9,10.3c2.8,1.6,5.6,3.1,8.4,4.8v0c0.3,0.2,0.7,0.4,1,0.5v-32.7C263.1,540.8,258.8,537,254.8,532.9"
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    width: 725.3,
    height: 780.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M402.9,570.4c-12,2.6-24.3,4-36.5,4.2c-11.5,0.2-23-0.7-34.3-2.6c-10-1.7-19.9-4.3-29.5-7.8v27.7 c11.7,3.4,23.7,5.7,35.7,7c13.9,1.5,27.9,1.8,41.9,0.8c13.5-1,26.9-3.2,39.9-6.6c1.3-0.3,2.6-0.7,3.8-1.1v-27.7 C417.1,566.8,410.1,568.8,402.9,570.4"
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    width: 725.3,
    height: 780.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M345.8,380.3v-25.8c-0.9,0.1-1.8,0.2-2.7,0.2c-11.2,1-22.3,2.8-33.2,5.6l8.4,24.8 C327.3,382.7,336.5,381.2,345.8,380.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    width: 725.3,
    height: 780.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "453.6,355.3 464.5,339.8 429.3,339.8 425.3,351.7 410.6,394.9 380.8,482.4 380.8,551.6 429.3,413.6  429.3,612 419.1,627.3 463.9,627.3 453.6,612  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    width: 725.3,
    height: 780.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M478.5,425.8c3.8,4.5,7.3,9.3,10.1,14.4c3.1-2.8,6.1-5.6,9.2-8.5c4.2-3.8,8.3-7.6,12.5-11.5 c1.2-1.1,2.5-2.2,3.7-3.4c-6.3-5.3-12.5-10.7-18.8-16c-3.6-3.1-7.1-6.2-10.9-9.1c-3.7-2.9-7.6-5.6-11.6-8.1 c-2.3-1.5-4.7-2.9-7-4.3c-2-1.1-3.9-2.3-6-3.2c-0.3-0.1-0.6-0.3-0.8-0.4v32.1C466.1,413.1,472.8,419.1,478.5,425.8"
  }))), /*#__PURE__*/React.createElement("g", null, _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    width: 725.3,
    height: 780.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M492.1,516.9c-1.1-1-2.3-2.1-3.4-3.1c-6.1,11.1-15.1,20.7-25,28.6c-1.6,1.3-3.2,2.5-4.8,3.7v32.1 c0.3-0.1,0.6-0.3,0.8-0.4c4-1.8,7.7-4.2,11.4-6.5c4-2.5,7.9-5.1,11.7-8c3.8-2.9,7.4-6,11-9c3.5-3,7-6,10.5-8.9 c3.2-2.8,6.4-5.6,9.7-8.3c-2.7-2.5-5.4-5-8.1-7.5C501.3,525.4,496.7,521.2,492.1,516.9"
  }))), /*#__PURE__*/React.createElement("g", null, _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_21_",
    width: 725.3,
    height: 780.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "363.2,627.3 383.6,605.6 342.8,605.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    width: 725.3,
    height: 780.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M375.4,569.2V380.3c0,0,15.9,0.7,32.8,5l8.5-25.1c-10.4-2.6-21-4.4-31.7-5.4c-3.2-0.3-6.4-0.5-9.7-0.7 l0.1-31.1c0,0,19.4,0.1,26.8,1c7.4,0.8,19.5,4.9,19.5,4.9l0.6-29.6h-81.6l9.3,15.4l1.1,9.1v245.4 C359.8,569.7,365.2,569.6,375.4,569.2"
  }))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_25_",
    width: 725.3,
    height: 780.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M38.8,125.8c10.9-3.6,21.8-6.9,32.8-10.1c2.5,22.9,5,45.7,7.5,68.6c0.5,7,0.7,10.4,1.2,17.4 c0.6-7.3,0.9-10.9,1.5-18.1c2.6-24.3,5.3-48.6,7.9-72.9c11.1-3,22.2-5.8,33.4-8.4v156.4c-10,2.3-14.9,3.6-24.9,6.2v-96.5 c-0.6,9.9-0.9,14.8-1.5,24.7c-2.7,24.8-5.4,49.6-8.1,74.4c-7.1,1.9-10.6,2.9-17.7,4.9c-2.7-23.2-5.4-46.4-8.1-69.6 c-0.6-9.6-0.9-14.4-1.4-24v96.5c-9.1,2.7-13.6,4.1-22.7,7.1V125.8"
  }))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_27_",
    width: 725.3,
    height: 780.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M133.5,99.9c17.3-3.9,34.7-7.4,52.2-10.3v25.5c-10.5,1.8-15.7,2.8-26.2,4.8V159c10.2-2,15.3-3,25.5-4.7v25.1 c-10.2,1.8-15.3,2.7-25.5,4.7v42.4c10.5-2.1,15.7-3,26.2-4.8V246c-17.5,3-34.9,6.5-52.2,10.3V99.9"
  }))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_29_",
    width: 725.3,
    height: 780.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M196.1,87.8c10.5-1.7,15.8-2.5,26.3-3.9v132.1c9.4-1.3,14.1-1.9,23.6-2.9v24.3c-16.7,2-33.3,4.2-49.9,6.8 V87.8z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_31_",
    width: 725.3,
    height: 780.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M255.1,80c11.6-1.2,23.2-2.2,34.7-3c25.6-2.7,29.5,17.2,29.7,37.8c0.1,10.7,1.6,28.6-10,34.9 c14.3,4.6,11.1,28.6,11.1,39.6c0,21.6-5,43.1-30.5,44.1c-11.7,0.8-23.3,1.8-35,3V80z M287.1,142.2c6.8-0.5,7.2-3.7,7.2-20.6 s-0.2-20.5-7.2-20c-2.4,0.2-3.6,0.3-6,0.4v40.5C283.5,142.5,284.7,142.4,287.1,142.2 M287.5,210c7.3-0.5,7.7-5.4,7.7-22.1 s-0.4-20.9-7.7-20.4c-2.6,0.2-3.8,0.3-6.4,0.5v42.4C283.7,210.2,285,210.1,287.5,210"
  }))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_33_",
    width: 725.3,
    height: 780.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M407.4,187.5V75.4c10.6,0.4,15.9,0.7,26.5,1.5v112.7c0,16.7,0.4,20.5,7.9,21s7.9-3.2,7.9-19.8V78.1 c10.3,0.9,15.5,1.3,25.8,2.5v112.1c0.5,25.6-5.5,44.3-34.3,42.5C412.7,233.3,407.2,212.6,407.4,187.5"
  }))), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_35_",
    width: 725.3,
    height: 780.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M484.8,81.6c11.7,1.3,23.4,2.9,35,4.7c27.9,4.5,30.3,31.2,30.2,54.6c0,14.3,1.4,35.9-12.5,45.1 c3.9,20.5,7.7,41,11.6,61.5c-10.2-1.8-15.3-2.7-25.6-4.3c-3.4-18.2-6.8-36.5-10.2-54.7c-1.3-0.2-1.9-0.3-3.2-0.5v53.2 c-10.2-1.4-15.3-2.1-25.5-3.3C484.8,185.8,484.8,133.7,484.8,81.6 M516.4,164.7c7.4,1.1,7.3-6.1,7.6-26.3c0.1-7.5,2.6-25.2-7.6-28 c-2.5-0.4-3.7-0.5-6.1-0.9v54.3C512.7,164.1,513.9,164.3,516.4,164.7"
  }))), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_37_",
    width: 725.3,
    height: 780.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M558.1,92.8c11.1,2.1,16.7,3.2,27.8,5.6c3.6,17.6,7.3,35.1,10.9,52.7c1.8,9.3,2.6,14,4.4,23.4v-72.6 c9.8,2.3,14.7,3.5,24.5,6v156.4c-9.9-2.6-14.8-3.8-24.7-6.1c-4.7-21.2-9.4-42.4-14-63.5c-1.8-8.7-2.7-13-4.4-21.6v81 c-9.7-2.1-14.6-3.1-24.4-4.9L558.1,92.8"
  }))), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_39_",
    width: 725.3,
    height: 780.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    style: {
      overflow: "visible"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M635.9,110.6c17.2,4.7,34.4,9.7,51.3,15.2v25.5c-10.2-3.3-15.3-4.9-25.6-8v39.1c10,3,15,4.5,25,7.8v25.1 c-10-3.2-15-4.8-25-7.7V250c10.3,3,15.4,4.6,25.6,8v24.3c-17-5.5-34.1-10.6-51.3-15.2C635.9,267,635.9,110.6,635.9,110.6z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_41_",
    width: 725.3,
    height: 780.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M338.2,224.1c-8.9-10.6-9.3-30.6-9.3-71.6c0-39.3,0.4-59.3,8.7-70.3c5.1-6.3,13.5-9.1,26.2-9.1 c12.7,0,21.3,2.7,26,8.7c8.7,10.8,8.9,30.8,8.9,70.7c0,43.7-0.2,62.7-9.1,72.4c-4.6,5.3-13.1,7.2-25.7,7.2 C351.3,232.1,342.9,229.8,338.2,224.1 M372.2,153.2c0-51.1,0-54-8.4-54c-8.2,0-8.2,3-8.2,54c0,51.5,0,54.2,8.2,54.2 C372.2,207.4,372.2,204.7,372.2,153.2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMelb);
export default __webpack_public_path__ + "static/media/melb.8e4de65907020ab4e527c0ae99bce5ca.svg";
export { ForwardRef as ReactComponent };